<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {};
  },
  computed: {
    // primaryColor() {
    //   return this.sharedState.design !== null
    //     ? '#' + this.sharedState.design.primary_color
    //     : 'transparent';
    // },
  },
  created() {
    this.root = document.documentElement;
  },
  mounted() {
    this.changeStyle();
  },
  watch: {
    // primaryColor: {
    //   handler: function () {
    //     this.changeStyle();
    //   },
    // },
  },
  methods: {
    changeStyle() {
      this.$nextTick(() => {
        //this.root.style.setProperty('--primary-color', this.primaryColor);
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/common.scss';
.storeWrapper,
.storeWrapperModal {
  // .primary-color:not(.btn) {
  //   color: var(--primary-color) !important;
  // }

  // .btn.primary-color {
  //   background: var(--primary-color) !important;
  //   border-color: var(--primary-color) !important;
  //   &:hover:not(.disabled) {
  //     opacity: 0.75;
  //     border-color: var(--primary-color) !important;
  //   }
  //   &:focus {
  //     box-shadow: none !important;
  //   }
  // }

  // .custom-control-input {
  //   &:checked ~ .custom-control-label::before {
  //     border-color: var(--primary-color) !important;
  //     background-color: var(--primary-color) !important;
  //   }
  //   &:not(:disabled):active ~ .custom-control-label::before {
  //     background-color: var(--primary-color) !important;
  //     border-color: var(--primary-color) !important;
  //   }

  //   &:focus {
  //     box-shadow: none !important;

  //     ~ .custom-control-label::before {
  //       box-shadow: none !important;
  //       border-color: var(--primary-color) !important;
  //     }
  //     &:not(:checked) ~ .custom-control-label::before {
  //       border-color: var(--primary-color) !important;
  //     }
  //   }
  // }
}

.form-control:focus {
  border-color: var(--primary-color) !important;

  box-shadow: none !important;
}

.custom-select {
  //border-color: var(--primary-color) !important;
  &:focus {
    box-shadow: none !important;
    border-color: var(--primary-color);
  }
}

// @import 'assets/css/reset';
// // :root {
// //   --pepe: #000;
// // }

// // $primary: var(--pepe);

// @import 'node_modules/bootstrap/scss/bootstrap';

// @import 'node_modules/bootstrap-vue/src/index.scss';

// @import 'assets/css/notifications';
</style>
